export const INPUT_CONFIG = {
    imageFormats: '.jpg, .png, .jpeg, .heic',
    inputType: 'file',
    inputId: 'ImagePicker'
  };